<template>
<form @submit.prevent="onSubmit">
    <div class="row">
        <div class="col-12 col-sm-12">
            <price-search-contract-length-selector />
            <price-search-annual-mileage-selector/>

            <span class="font-weight-bold">
                        Bérleti díj
                      </span>
            <div class="bootstrap-slider-container">
                <b-form-slider
                    v-model="rangeValue"
                    range
                    :step="1000"
                    :min="min_price"
                    :max="max_price"
                    @slide-stop="updateMinMax()">
                </b-form-slider>
            </div>


        </div>

        <div class="col-12 col-sm-6">
            <label :for="'min_price'">Minimum bérleti díj</label>

            <input
                :id="'min_price'"
                :value="rangeValue[0]+' Ft'"
                type="text"
                disabled
                class="form-control form-control-sm"
            >
        </div>

        <div class="col-12 col-sm-6">
            <label :for="'max_price'">Maximum bérleti díj</label>
            <input
                :id="'max_price'"
                :value="rangeValue[1] +' Ft'"
                type="text"
                disabled
                class="form-control form-control-sm"
            >

        </div>
    </div>
    <button
        type="submit"
        class="btn btn-block btn-primary mt-3"
    >
        Keresés
    </button>
</form>
</template>


<script>
  import {Vue, Component, Prop} from 'vue-property-decorator';
  import {namespace} from 'vuex-class';
  import PriceSearchAnnualMileageSelector from "./PriceSearchAnnualMileageSelector";
  import PriceSearchContractLengthSelector from "./PriceSearchContractLengthSelector";

  const priceSearchModule = namespace('price_search');

  function paramsToObject(entries) {
    let result = {};
    for (let entry of entries) { // each 'entry' is a [key, value] tupple
      const [key, value] = entry;
      result[key] = value;
    }
    return result;
  }

  @Component({
    components: {
      PriceSearchContractLengthSelector,
      PriceSearchAnnualMileageSelector}
  })

  export default class PriceSearchForm extends Vue {
    
    @Prop(String) url;
    @Prop(Number) max_price;
    @Prop(Number) min_price;

    @priceSearchModule.Getter('getAnnualMileage') annualMileage;
    @priceSearchModule.Getter('getContractLength') contractLength;
    @priceSearchModule.State('filters') filters;
    @priceSearchModule.Mutation('setFilters') setFilters;
    @priceSearchModule.Mutation('setAnnualMileage') setAnnualMileage;
    @priceSearchModule.Mutation('setContractLength') setContractLength;

    initialPayment = 10;
    rangeValue = null;

    created() {

      const params = new URLSearchParams(location.search);
      const filters = paramsToObject(params.entries());

      this.rangeValue = [
        filters.min_price ? parseInt(filters.min_price) : this.min_price,
        filters.max_price ? parseInt(filters.max_price) : this.max_price
      ];

      filters.annualMileage = filters.annualMileage?filters.annualMileage:this.annualMileage;
      filters.contractLength = filters.contractLength?filters.contractLength:this.contractLength;

      this.setAnnualMileage(parseInt(filters.annualMileage));
      this.setContractLength(parseInt(filters.contractLength));

      this.setFilters({
        ...filters,
        min_price: this.rangeValue[0],
        max_price: this.rangeValue[1]
      });

    }

    onSubmit() {

      const url = new URL(this.url);
      for (let key in this.filters) {
          url.searchParams.append(key, this.filters[key]);
      }

      location.href = url.href

    }

    updateMinMax() {
      this.filters.min_price = this.rangeValue[0];
      this.filters.max_price = this.rangeValue[1];
    }
  }
</script>
